import './Card.css';
import Card from './Card';
export default Card;



// WEBPACK FOOTER //
// ./src/components/Game/components/Card/index.js